import React, { PropsWithChildren } from 'react';
import { NavLink } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { ResponsiveBackToListCol } from './ResponsiveContextProvider';

interface ResponsiveHeaderProps extends PropsWithChildren<{}> {
  to: string;
}

/**
 * Top header on detail view. Shows "back to list" icon on small screens
 */
export default function ResponsiveHeaderRow({ to, children }: ResponsiveHeaderProps) {
  return (
    <Row>
      <ResponsiveBackToListCol className="d-md-none mt-1">
        <NavLink to={to}>← Zpět na seznam</NavLink>
      </ResponsiveBackToListCol>

      {children && <Col className="text-right">{children}</Col>}
    </Row>
  );
}
